<template>
  <div class="page">
    <div id="inicio" />
    <Navbar />
    <Banner :haSingleImg="false" :hasBgBlur="true" :galeria="bloco.galeria" />
    <v-container>
      <v-col>
        <v-row>
          <Title
            :sub1="nomeRoteiro"
            :titulo="bloco.nome"
            :sub2="bloco.morada"
            :hasVideo="hasVideo"
            :video="bloco.video"
          />
        </v-row>

        <v-row>
          <vue-simple-markdown class="body-1 text-justify" :source="bloco.descricao"></vue-simple-markdown>
        </v-row>

        <v-row>
          <Map
            :selectedBloco="selectedBloco"
            :centredBloco="centredBloco"
            :idRoteiro="idRoteiro"
            :blocos="roteiro.blocos"
          />
        </v-row>
      </v-col>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import Navbar from "@/components/Navbar.vue";
import Map from "@/components/Map.vue";
import Footer from "@/components/Footer.vue";
import Title from "@/components/Title.vue";
import _ from "lodash";
import { getCentralMap } from "../globalFunctions";

export default {
  name: "Bloco",
  components: {
    Navbar,
    Banner,
    Title,
    Map,
    Footer
  },
  destroyed() {
    this.bloco = {};
    this.id = null;
  },
  watch: {
    // call again the method if the route changes
    $route: "getData"
  },
  async mounted() {
    var _roteiro = this.$store.getters.roteiro;

    if (!_.isNull(_roteiro)) {
      if (_roteiro.roteiro_id == this.idRoteiro) {
        await this.getData(false, _roteiro);
      } else {
        await this.getData(true, null);
      }
    } else {
      await this.getData(true, null);
    }

    //scroll para o topo
    var elmnt = document.getElementById("inicio");
    elmnt.scrollIntoView();
  },
  data() {
    return {
      idRoteiro: this.$route.params.id,
      roteiro: null,
      nomeRoteiro: "",
      idBloco: this.$route.params.idBloco,
      hasVideo: false,
      bloco: {},
      titulos: [],
      selectedBloco: 0,
      centredBloco: { lat: 0, lng: 0 }
    };
  },
  methods: {
    async getData(needApi, _roteiro) {
      var _centredBloco = null;
      if (needApi) {
        _roteiro = await this.$store.dispatch("setRoteiro", this.idRoteiro);
        _centredBloco = await getCentralMap(this.roteiro);

        this.centredBloco = {
          lat: _centredBloco.latitude,
          lng: _centredBloco.longitude
        };
        this.nomeRoteiro = _roteiro.nome;
        this.roteiro = _roteiro;
        _roteiro.blocos.map((bloco, index) => {
          if (bloco.bloco_id == this.idBloco) {
            this.selectedBloco = index;
            this.bloco = bloco;
          }
        });
      } else {
        this.nomeRoteiro = _roteiro.nome;
        this.roteiro = _roteiro;
        _centredBloco = await getCentralMap(this.roteiro);

        this.centredBloco = {
          lat: _centredBloco.latitude,
          lng: _centredBloco.longitude
        };
        _roteiro.blocos.map((bloco, index) => {
          if (bloco.bloco_id == this.idBloco) {
            this.selectedBloco = index;
            this.bloco = bloco;
          }
        });
      }

      if (_.isNull(this.bloco.video)) {
        this.hasVideo = false;
      } else {
        this.hasVideo = true;
      }
    }
  }
};
</script>
